import {
  IPaginationSet,
  ResponseModel,
  IAdsModel,
  IAdminSearchModel
} from "@/models";
import VetQuestApi from "../VetQuestApi";
import { IUpdateBulkAdModel } from "@/models/viewmodel/IUpdateBulkAdModel";

export abstract class PostService {
  static BASE_URL: string = "admin/post";
  static async GetPendingAuthorization(
    pageIndex: number,
    pageSize: number
  ): Promise<ResponseModel<IPaginationSet<IAdsModel>>> {
    let response = new ResponseModel<IPaginationSet<IAdsModel>>(
      0,
      {} as IPaginationSet<IAdsModel>
    );
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}/pendingauthorization?pageIndex=${pageIndex}&pageSize=${pageSize}`
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IPaginationSet<IAdsModel>>(
        error.response.status,
        {} as IPaginationSet<IAdsModel>,
        error.response
      );
      return response;
    }
  }

  static async Search(
    search: IAdminSearchModel
  ): Promise<ResponseModel<IPaginationSet<IAdsModel>>> {
    let response = new ResponseModel<IPaginationSet<IAdsModel>>(
      0,
      {} as IPaginationSet<IAdsModel>
    );
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/search`,
        search
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IPaginationSet<IAdsModel>>(
        error.response.status,
        {} as IPaginationSet<IAdsModel>,
        error.response
      );
      return response;
    }
  }

  static async Delete(id: number): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().delete(
        `${this.BASE_URL}/${id}`
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }

  static async UpdateMultiple(
    ads: Array<IUpdateBulkAdModel>
  ): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/UpdateMultiple`,
        ads
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }

  static async SendEmailPendingAuthorization(
    ads: Array<IUpdateBulkAdModel>
  ): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/SendEmailPendingAuthorization`,
        ads
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }

  static async DeleteMultiple(
    ads: number[]
  ): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/DeleteMultiple`,
        ads
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }

  static async Blacklist(
    id: number,
    add: boolean
  ): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().put(
        `${this.BASE_URL}/Blacklist/${id}?add=${add}`,
        {}
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }
  static async Create(email: string): Promise<ResponseModel<IAdsModel>> {
    let response = new ResponseModel<IAdsModel>(0, {} as IAdsModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/Blacklist`,
        {
          email
        }
      );
      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IAdsModel>(
        error.response.status,
        {} as IAdsModel,
        error.response
      );
      return response;
    }
  }
}
